import { Locales } from '@griply/types';
import { ID } from 'shared/types/id';

import { createPushToken } from './create-push-token';
import { fetchFreshPushToken } from './fetch-fresh-push-token';
import { getPushNotificationToken } from './helpers';
import { updateUser } from './update-user';

export const setNotificationsOnUser = async (userId: ID, locale: Locales) => {
  if ('Notification' in window && Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      throw new Error('Notification permission not granted');
    }
  }

  // typed registration errors must reach the toggle — getPushToken would swallow them
  const token =
    getPushNotificationToken(userId) ?? (await fetchFreshPushToken());

  if (!token) {
    throw new Error('Failed to retrieve push token');
  }

  await updateUser({
    notifications: {
      taskReminder: { desktop: true },
      taskSummary: { desktop: true },
      weeklyReview: { desktop: true },
    },
  });

  await createPushToken(userId, token, locale);
};
